export const TSHEET_STATUS_COLOR = {
    connected: 'success',
    pending: 'warning',
};
